<app-shared-business-metadata-v2 [metadata]="metadata" />

<app-card class="flex-basis-100 mb-12" *ngIf="hasBasicInfo()">
  <div cardTitle i18n>Informations RC Entreprise</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          metadata?.reimbursedSum !== undefined ||
          originalMetadata?.reimbursedSum !== undefined
        "
      >
        <span class="card__label" i18n>Franchise (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.reimbursedSum !== metadata.reimbursedSum,
            }"
            >{{ metadata.reimbursedSum }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.reimbursedSum !== metadata.reimbursedSum &&
              originalMetadata.reimbursedSum !== null &&
              originalMetadata.reimbursedSum !== undefined
            "
            >{{ originalMetadata.reimbursedSum }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.insuredSum !== undefined ||
          originalMetadata?.insuredSum !== undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.insuredSum !== metadata.insuredSum,
            }"
            >{{ metadata.insuredSum }} CHF</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.insuredSum !== metadata.insuredSum &&
              originalMetadata.insuredSum !== null &&
              originalMetadata.insuredSum !== undefined
            "
            >{{ originalMetadata.insuredSum }} CHF</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.additionalCovers?.length ||
          originalMetadata?.additionalCovers?.length
        "
      >
        <span class="card__label" i18n>Couvertures supplémentaires</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getAdditionalCoversText(originalMetadata.additionalCovers) !==
                  getAdditionalCoversText(metadata.additionalCovers),
            }"
            >{{ getAdditionalCoversText(metadata.additionalCovers) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getAdditionalCoversText(originalMetadata.additionalCovers) !==
                getAdditionalCoversText(metadata.additionalCovers) &&
              getAdditionalCoversText(originalMetadata.additionalCovers) !==
                null &&
              getAdditionalCoversText(originalMetadata.additionalCovers) !==
                undefined
            "
            >{{
              getAdditionalCoversText(originalMetadata.additionalCovers)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    metadata?.coverageValidityDuration !== undefined ||
    originalMetadata?.coverageValidityDuration !== undefined
  "
>
  <div cardTitle i18n>Prestations assurées</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div class="card__row">
        <span class="card__label" i18n>Validité temporelle</span>
        <span class="card__value">{{
          getBusinessRcCompanyCoverageValidityLabel(
            metadata.coverageValidityDuration
          )
        }}</span>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isCompanyPersonalDamageCoverageEmpty(
      metadata?.companyPersonalDamageCoverage
    ) ||
    !isCompanyPersonalDamageCoverageEmpty(
      originalMetadata?.companyPersonalDamageCoverage
    )
  "
>
  <div cardTitle i18n>Dommages corporels et matériels</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.companyPersonalDamageCoverage?.personalPropertyDamage !==
            null &&
            metadata?.companyPersonalDamageCoverage?.personalPropertyDamage !==
              undefined) ||
          (originalMetadata?.companyPersonalDamageCoverage
            ?.personalPropertyDamage !== null &&
            originalMetadata?.companyPersonalDamageCoverage
              ?.personalPropertyDamage !== undefined)
        "
      >
        <span class="card__label" i18n>Dommages aux biens personnels</span>
        <span class="card__value">{{
          getBooleanLabel(
            metadata.companyPersonalDamageCoverage.personalPropertyDamage
          )
        }}</span>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.companyPersonalDamageCoverage?.insuredSum !== undefined ||
          originalMetadata?.companyPersonalDamageCoverage?.insuredSum !==
            undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.companyPersonalDamageCoverage.insuredSum !==
                  metadata.companyPersonalDamageCoverage.insuredSum,
            }"
            >{{ metadata.companyPersonalDamageCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.companyPersonalDamageCoverage.insuredSum !==
                metadata.companyPersonalDamageCoverage.insuredSum &&
              originalMetadata.companyPersonalDamageCoverage.insuredSum !==
                null &&
              originalMetadata.companyPersonalDamageCoverage.insuredSum !==
                undefined
            "
            >{{
              originalMetadata.companyPersonalDamageCoverage.insuredSum
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.companyPersonalDamageCoverage?.doubleWarranty !== null &&
            metadata?.companyPersonalDamageCoverage?.doubleWarranty !==
              undefined) ||
          (originalMetadata?.companyPersonalDamageCoverage?.doubleWarranty !==
            null &&
            originalMetadata?.companyPersonalDamageCoverage?.doubleWarranty !==
              undefined)
        "
      >
        <span class="card__label" i18n>Double garantie</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.companyPersonalDamageCoverage.doubleWarranty
                ) !==
                  getBooleanLabel(
                    metadata.companyPersonalDamageCoverage.doubleWarranty
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.companyPersonalDamageCoverage.doubleWarranty
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.companyPersonalDamageCoverage.doubleWarranty
              ) !==
                getBooleanLabel(
                  metadata.companyPersonalDamageCoverage.doubleWarranty
                ) &&
              getBooleanLabel(
                originalMetadata.companyPersonalDamageCoverage.doubleWarranty
              ) !== null &&
              getBooleanLabel(
                originalMetadata.companyPersonalDamageCoverage.doubleWarranty
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.companyPersonalDamageCoverage.doubleWarranty
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.companyPersonalDamageCoverage?.dcFranchise !== undefined ||
          originalMetadata?.companyPersonalDamageCoverage?.dcFranchise !==
            undefined
        "
      >
        <span class="card__label" i18n>Franchise DC</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.companyPersonalDamageCoverage.dcFranchise !==
                  metadata.companyPersonalDamageCoverage.dcFranchise,
            }"
            >{{ metadata.companyPersonalDamageCoverage.dcFranchise }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.companyPersonalDamageCoverage.dcFranchise !==
                metadata.companyPersonalDamageCoverage.dcFranchise &&
              originalMetadata.companyPersonalDamageCoverage.dcFranchise !==
                null &&
              originalMetadata.companyPersonalDamageCoverage.dcFranchise !==
                undefined
            "
            >{{
              originalMetadata.companyPersonalDamageCoverage.dcFranchise
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.companyPersonalDamageCoverage?.dmFranchise !== undefined ||
          originalMetadata?.companyPersonalDamageCoverage?.dmFranchise !==
            undefined
        "
      >
        <span class="card__label" i18n>Franchise DM</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.companyPersonalDamageCoverage.dmFranchise !==
                  metadata.companyPersonalDamageCoverage.dmFranchise,
            }"
            >{{ metadata.companyPersonalDamageCoverage.dmFranchise }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.companyPersonalDamageCoverage.dmFranchise !==
                metadata.companyPersonalDamageCoverage.dmFranchise &&
              originalMetadata.companyPersonalDamageCoverage.dmFranchise !==
                null &&
              originalMetadata.companyPersonalDamageCoverage.dmFranchise !==
                undefined
            "
            >{{
              originalMetadata.companyPersonalDamageCoverage.dmFranchise
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.companyPersonalDamageCoverage?.financialLoss !== null &&
            metadata?.companyPersonalDamageCoverage?.financialLoss !==
              undefined) ||
          (originalMetadata?.companyPersonalDamageCoverage?.financialLoss !==
            null &&
            originalMetadata?.companyPersonalDamageCoverage?.financialLoss !==
              undefined)
        "
      >
        <span class="card__label" i18n>Préjudices de fortune</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.companyPersonalDamageCoverage.financialLoss
                ) !==
                  getBooleanLabel(
                    metadata.companyPersonalDamageCoverage.financialLoss
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.companyPersonalDamageCoverage.financialLoss
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.companyPersonalDamageCoverage.financialLoss
              ) !==
                getBooleanLabel(
                  metadata.companyPersonalDamageCoverage.financialLoss
                ) &&
              getBooleanLabel(
                originalMetadata.companyPersonalDamageCoverage.financialLoss
              ) !== null &&
              getBooleanLabel(
                originalMetadata.companyPersonalDamageCoverage.financialLoss
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.companyPersonalDamageCoverage.financialLoss
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.companyPersonalDamageCoverage?.financialLossInsuredSum !==
            undefined ||
          originalMetadata?.companyPersonalDamageCoverage
            ?.financialLossInsuredSum !== undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance en PF</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.companyPersonalDamageCoverage
                  .financialLossInsuredSum !==
                  metadata.companyPersonalDamageCoverage
                    .financialLossInsuredSum,
            }"
            >{{
              metadata.companyPersonalDamageCoverage.financialLossInsuredSum
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.companyPersonalDamageCoverage
                .financialLossInsuredSum !==
                metadata.companyPersonalDamageCoverage
                  .financialLossInsuredSum &&
              originalMetadata.companyPersonalDamageCoverage
                .financialLossInsuredSum !== null &&
              originalMetadata.companyPersonalDamageCoverage
                .financialLossInsuredSum !== undefined
            "
            >{{
              originalMetadata.companyPersonalDamageCoverage
                .financialLossInsuredSum
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.companyPersonalDamageCoverage?.financialLossDeductible !==
            undefined ||
          originalMetadata?.companyPersonalDamageCoverage
            ?.financialLossDeductible !== undefined
        "
      >
        <span class="card__label" i18n>Franchise en PF</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.companyPersonalDamageCoverage
                  .financialLossDeductible !==
                  metadata.companyPersonalDamageCoverage
                    .financialLossDeductible,
            }"
            >{{
              metadata.companyPersonalDamageCoverage.financialLossDeductible
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.companyPersonalDamageCoverage
                .financialLossDeductible !==
                metadata.companyPersonalDamageCoverage
                  .financialLossDeductible &&
              originalMetadata.companyPersonalDamageCoverage
                .financialLossDeductible !== null &&
              originalMetadata.companyPersonalDamageCoverage
                .financialLossDeductible !== undefined
            "
            >{{
              originalMetadata.companyPersonalDamageCoverage
                .financialLossDeductible
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.companyPersonalDamageCoverage
            ?.financialLossDataViolationCoverage !== null &&
            metadata?.companyPersonalDamageCoverage
              ?.financialLossDataViolationCoverage !== undefined) ||
          (originalMetadata?.companyPersonalDamageCoverage
            ?.financialLossDataViolationCoverage !== null &&
            originalMetadata?.companyPersonalDamageCoverage
              ?.financialLossDataViolationCoverage !== undefined)
        "
      >
        <span class="card__label" i18n
          >Couverture en PF sur la violation des lois sur la protection des
          données</span
        >
        <span class="card__value">{{
          getBooleanLabel(
            metadata.companyPersonalDamageCoverage
              .financialLossDataViolationCoverage
          )
        }}</span>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.environmentDamageBasicCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.environmentDamageBasicCoverage)
  "
>
  <div cardTitle i18n>Atteinte à l'environnement : base</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.environmentDamageBasicCoverage?.withCoverage !== null &&
            metadata?.environmentDamageBasicCoverage?.withCoverage !==
              undefined) ||
          (originalMetadata?.environmentDamageBasicCoverage?.withCoverage !==
            null &&
            originalMetadata?.environmentDamageBasicCoverage?.withCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.environmentDamageBasicCoverage.withCoverage
                ) !==
                  getBooleanLabel(
                    metadata.environmentDamageBasicCoverage.withCoverage
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.environmentDamageBasicCoverage.withCoverage
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.environmentDamageBasicCoverage.withCoverage
              ) !==
                getBooleanLabel(
                  metadata.environmentDamageBasicCoverage.withCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.environmentDamageBasicCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.environmentDamageBasicCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.environmentDamageBasicCoverage.withCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.environmentDamageBasicCoverage?.insuredSum !== undefined ||
          originalMetadata?.environmentDamageBasicCoverage?.insuredSum !==
            undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.environmentDamageBasicCoverage.insuredSum !==
                  metadata.environmentDamageBasicCoverage.insuredSum,
            }"
            >{{ metadata.environmentDamageBasicCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.environmentDamageBasicCoverage.insuredSum !==
                metadata.environmentDamageBasicCoverage.insuredSum &&
              originalMetadata.environmentDamageBasicCoverage.insuredSum !==
                null &&
              originalMetadata.environmentDamageBasicCoverage.insuredSum !==
                undefined
            "
            >{{
              originalMetadata.environmentDamageBasicCoverage.insuredSum
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.environmentDamageBasicCoverage?.deductible !== undefined ||
          originalMetadata?.environmentDamageBasicCoverage?.deductible !==
            undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.environmentDamageBasicCoverage.deductible !==
                  metadata.environmentDamageBasicCoverage.deductible,
            }"
            >{{ metadata.environmentDamageBasicCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.environmentDamageBasicCoverage.deductible !==
                metadata.environmentDamageBasicCoverage.deductible &&
              originalMetadata.environmentDamageBasicCoverage.deductible !==
                null &&
              originalMetadata.environmentDamageBasicCoverage.deductible !==
                undefined
            "
            >{{
              originalMetadata.environmentDamageBasicCoverage.deductible
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.environmentDamageExtendedCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.environmentDamageExtendedCoverage)
  "
>
  <div cardTitle i18n>Atteinte à l'environnement : étendue</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.environmentDamageExtendedCoverage?.withCoverage !== null &&
            metadata?.environmentDamageExtendedCoverage?.withCoverage !==
              undefined) ||
          (originalMetadata?.environmentDamageExtendedCoverage?.withCoverage !==
            null &&
            originalMetadata?.environmentDamageExtendedCoverage
              ?.withCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.environmentDamageExtendedCoverage
                    .withCoverage
                ) !==
                  getBooleanLabel(
                    metadata.environmentDamageExtendedCoverage.withCoverage
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.environmentDamageExtendedCoverage.withCoverage
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.environmentDamageExtendedCoverage.withCoverage
              ) !==
                getBooleanLabel(
                  metadata.environmentDamageExtendedCoverage.withCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.environmentDamageExtendedCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.environmentDamageExtendedCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.environmentDamageExtendedCoverage.withCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.environmentDamageExtendedCoverage?.insuredSum !==
            undefined ||
          originalMetadata?.environmentDamageExtendedCoverage?.insuredSum !==
            undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.environmentDamageExtendedCoverage
                  .insuredSum !==
                  metadata.environmentDamageExtendedCoverage.insuredSum,
            }"
            >{{ metadata.environmentDamageExtendedCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.environmentDamageExtendedCoverage.insuredSum !==
                metadata.environmentDamageExtendedCoverage.insuredSum &&
              originalMetadata.environmentDamageExtendedCoverage.insuredSum !==
                null &&
              originalMetadata.environmentDamageExtendedCoverage.insuredSum !==
                undefined
            "
            >{{
              originalMetadata.environmentDamageExtendedCoverage.insuredSum
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.environmentDamageExtendedCoverage?.deductible !==
            undefined ||
          originalMetadata?.environmentDamageExtendedCoverage?.deductible !==
            undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.environmentDamageExtendedCoverage
                  .deductible !==
                  metadata.environmentDamageExtendedCoverage.deductible,
            }"
            >{{ metadata.environmentDamageExtendedCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.environmentDamageExtendedCoverage.deductible !==
                metadata.environmentDamageExtendedCoverage.deductible &&
              originalMetadata.environmentDamageExtendedCoverage.deductible !==
                null &&
              originalMetadata.environmentDamageExtendedCoverage.deductible !==
                undefined
            "
            >{{
              originalMetadata.environmentDamageExtendedCoverage.deductible
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.damagePreventionCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.damagePreventionCoverage)
  "
>
  <div cardTitle i18n>Frais de prévention de dommages</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.damagePreventionCoverage?.withCoverage !== null &&
            metadata?.damagePreventionCoverage?.withCoverage !== undefined) ||
          (originalMetadata?.damagePreventionCoverage?.withCoverage !== null &&
            originalMetadata?.damagePreventionCoverage?.withCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.damagePreventionCoverage.withCoverage
                ) !==
                  getBooleanLabel(
                    metadata.damagePreventionCoverage.withCoverage
                  ),
            }"
            >{{
              getBooleanLabel(metadata.damagePreventionCoverage.withCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.damagePreventionCoverage.withCoverage
              ) !==
                getBooleanLabel(
                  metadata.damagePreventionCoverage.withCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.damagePreventionCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.damagePreventionCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.damagePreventionCoverage.withCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.damagePreventionCoverage?.insuredSum !== undefined ||
          originalMetadata?.damagePreventionCoverage?.insuredSum !== undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.damagePreventionCoverage.insuredSum !==
                  metadata.damagePreventionCoverage.insuredSum,
            }"
            >{{ metadata.damagePreventionCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.damagePreventionCoverage.insuredSum !==
                metadata.damagePreventionCoverage.insuredSum &&
              originalMetadata.damagePreventionCoverage.insuredSum !== null &&
              originalMetadata.damagePreventionCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.damagePreventionCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.damagePreventionCoverage?.deductible !== undefined ||
          originalMetadata?.damagePreventionCoverage?.deductible !== undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.damagePreventionCoverage.deductible !==
                  metadata.damagePreventionCoverage.deductible,
            }"
            >{{ metadata.damagePreventionCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.damagePreventionCoverage.deductible !==
                metadata.damagePreventionCoverage.deductible &&
              originalMetadata.damagePreventionCoverage.deductible !== null &&
              originalMetadata.damagePreventionCoverage.deductible !== undefined
            "
            >{{ originalMetadata.damagePreventionCoverage.deductible }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.misappropriationDamageCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.misappropriationDamageCoverage)
  "
>
  <div cardTitle i18n>Dommages de malversations</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.misappropriationDamageCoverage?.withCoverage !== null &&
            metadata?.misappropriationDamageCoverage?.withCoverage !==
              undefined) ||
          (originalMetadata?.misappropriationDamageCoverage?.withCoverage !==
            null &&
            originalMetadata?.misappropriationDamageCoverage?.withCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.misappropriationDamageCoverage.withCoverage
                ) !==
                  getBooleanLabel(
                    metadata.misappropriationDamageCoverage.withCoverage
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.misappropriationDamageCoverage.withCoverage
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.misappropriationDamageCoverage.withCoverage
              ) !==
                getBooleanLabel(
                  metadata.misappropriationDamageCoverage.withCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.misappropriationDamageCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.misappropriationDamageCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.misappropriationDamageCoverage.withCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.misappropriationDamageCoverage?.insuredSum !== undefined ||
          originalMetadata?.misappropriationDamageCoverage?.insuredSum !==
            undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.misappropriationDamageCoverage.insuredSum !==
                  metadata.misappropriationDamageCoverage.insuredSum,
            }"
            >{{ metadata.misappropriationDamageCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.misappropriationDamageCoverage.insuredSum !==
                metadata.misappropriationDamageCoverage.insuredSum &&
              originalMetadata.misappropriationDamageCoverage.insuredSum !==
                null &&
              originalMetadata.misappropriationDamageCoverage.insuredSum !==
                undefined
            "
            >{{
              originalMetadata.misappropriationDamageCoverage.insuredSum
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.misappropriationDamageCoverage?.deductible !== undefined ||
          originalMetadata?.misappropriationDamageCoverage?.deductible !==
            undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.misappropriationDamageCoverage.deductible !==
                  metadata.misappropriationDamageCoverage.deductible,
            }"
            >{{ metadata.misappropriationDamageCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.misappropriationDamageCoverage.deductible !==
                metadata.misappropriationDamageCoverage.deductible &&
              originalMetadata.misappropriationDamageCoverage.deductible !==
                null &&
              originalMetadata.misappropriationDamageCoverage.deductible !==
                undefined
            "
            >{{
              originalMetadata.misappropriationDamageCoverage.deductible
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.reputationRestorationCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.reputationRestorationCoverage)
  "
>
  <div cardTitle i18n>Frais de rétablissement de la réputation</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.reputationRestorationCoverage?.withCoverage !== null &&
            metadata?.reputationRestorationCoverage?.withCoverage !==
              undefined) ||
          (originalMetadata?.reputationRestorationCoverage?.withCoverage !==
            null &&
            originalMetadata?.reputationRestorationCoverage?.withCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.reputationRestorationCoverage.withCoverage
                ) !==
                  getBooleanLabel(
                    metadata.reputationRestorationCoverage.withCoverage
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.reputationRestorationCoverage.withCoverage
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.reputationRestorationCoverage.withCoverage
              ) !==
                getBooleanLabel(
                  metadata.reputationRestorationCoverage.withCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.reputationRestorationCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.reputationRestorationCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.reputationRestorationCoverage.withCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.reputationRestorationCoverage?.insuredSum !== undefined ||
          originalMetadata?.reputationRestorationCoverage?.insuredSum !==
            undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.reputationRestorationCoverage.insuredSum !==
                  metadata.reputationRestorationCoverage.insuredSum,
            }"
            >{{ metadata.reputationRestorationCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.reputationRestorationCoverage.insuredSum !==
                metadata.reputationRestorationCoverage.insuredSum &&
              originalMetadata.reputationRestorationCoverage.insuredSum !==
                null &&
              originalMetadata.reputationRestorationCoverage.insuredSum !==
                undefined
            "
            >{{
              originalMetadata.reputationRestorationCoverage.insuredSum
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.reputationRestorationCoverage?.deductible !== undefined ||
          originalMetadata?.reputationRestorationCoverage?.deductible !==
            undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.reputationRestorationCoverage.deductible !==
                  metadata.reputationRestorationCoverage.deductible,
            }"
            >{{ metadata.reputationRestorationCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.reputationRestorationCoverage.deductible !==
                metadata.reputationRestorationCoverage.deductible &&
              originalMetadata.reputationRestorationCoverage.deductible !==
                null &&
              originalMetadata.reputationRestorationCoverage.deductible !==
                undefined
            "
            >{{
              originalMetadata.reputationRestorationCoverage.deductible
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.structureDamagesCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.structureDamagesCoverage)
  "
>
  <div cardTitle i18n>Dommages aux ouvrages</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.structureDamagesCoverage?.withCoverage !== null &&
            metadata?.structureDamagesCoverage?.withCoverage !== undefined) ||
          (originalMetadata?.structureDamagesCoverage?.withCoverage !== null &&
            originalMetadata?.structureDamagesCoverage?.withCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.structureDamagesCoverage.withCoverage
                ) !==
                  getBooleanLabel(
                    metadata.structureDamagesCoverage.withCoverage
                  ),
            }"
            >{{
              getBooleanLabel(metadata.structureDamagesCoverage.withCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.structureDamagesCoverage.withCoverage
              ) !==
                getBooleanLabel(
                  metadata.structureDamagesCoverage.withCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.structureDamagesCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.structureDamagesCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.structureDamagesCoverage.withCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.structureDamagesCoverage?.insuredSum !== undefined ||
          originalMetadata?.structureDamagesCoverage?.insuredSum !== undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.structureDamagesCoverage.insuredSum !==
                  metadata.structureDamagesCoverage.insuredSum,
            }"
            >{{ metadata.structureDamagesCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.structureDamagesCoverage.insuredSum !==
                metadata.structureDamagesCoverage.insuredSum &&
              originalMetadata.structureDamagesCoverage.insuredSum !== null &&
              originalMetadata.structureDamagesCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.structureDamagesCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.structureDamagesCoverage?.deductible !== undefined ||
          originalMetadata?.structureDamagesCoverage?.deductible !== undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.structureDamagesCoverage.deductible !==
                  metadata.structureDamagesCoverage.deductible,
            }"
            >{{ metadata.structureDamagesCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.structureDamagesCoverage.deductible !==
                metadata.structureDamagesCoverage.deductible &&
              originalMetadata.structureDamagesCoverage.deductible !== null &&
              originalMetadata.structureDamagesCoverage.deductible !== undefined
            "
            >{{ originalMetadata.structureDamagesCoverage.deductible }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card class="flex-basis-100 mb-12" *ngIf="hasAdditionalOptions()">
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.importerInsured !== null &&
            metadata?.importerInsured !== undefined) ||
          (originalMetadata?.importerInsured !== null &&
            originalMetadata?.importerInsured !== undefined)
        "
      >
        <span class="card__label" i18n>Importateur assuré</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.importerInsured) !==
                  getBooleanLabel(metadata.importerInsured),
            }"
            >{{ getBooleanLabel(metadata.importerInsured) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.importerInsured) !==
                getBooleanLabel(metadata.importerInsured) &&
              getBooleanLabel(originalMetadata.importerInsured) !== null &&
              getBooleanLabel(originalMetadata.importerInsured) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.importerInsured) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.intangibleAssets !== null &&
            metadata?.intangibleAssets !== undefined) ||
          (originalMetadata?.intangibleAssets !== null &&
            originalMetadata?.intangibleAssets !== undefined)
        "
      >
        <span class="card__label" i18n>Biens immatériels</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.intangibleAssets) !==
                  getBooleanLabel(metadata.intangibleAssets),
            }"
            >{{ getBooleanLabel(metadata.intangibleAssets) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.intangibleAssets) !==
                getBooleanLabel(metadata.intangibleAssets) &&
              getBooleanLabel(originalMetadata.intangibleAssets) !== null &&
              getBooleanLabel(originalMetadata.intangibleAssets) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.intangibleAssets) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.eanBarcodes !== null &&
            metadata?.eanBarcodes !== undefined) ||
          (originalMetadata?.eanBarcodes !== null &&
            originalMetadata?.eanBarcodes !== undefined)
        "
      >
        <span class="card__label" i18n>Codes à barres EAN</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.eanBarcodes) !==
                  getBooleanLabel(metadata.eanBarcodes),
            }"
            >{{ getBooleanLabel(metadata.eanBarcodes) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.eanBarcodes) !==
                getBooleanLabel(metadata.eanBarcodes) &&
              getBooleanLabel(originalMetadata.eanBarcodes) !== null &&
              getBooleanLabel(originalMetadata.eanBarcodes) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.eanBarcodes) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.ionizingRadiation !== null &&
            metadata?.ionizingRadiation !== undefined) ||
          (originalMetadata?.ionizingRadiation !== null &&
            originalMetadata?.ionizingRadiation !== undefined)
        "
      >
        <span class="card__label" i18n>Rayonnement ionisant et laser</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.ionizingRadiation) !==
                  getBooleanLabel(metadata.ionizingRadiation),
            }"
            >{{ getBooleanLabel(metadata.ionizingRadiation) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.ionizingRadiation) !==
                getBooleanLabel(metadata.ionizingRadiation) &&
              getBooleanLabel(originalMetadata.ionizingRadiation) !== null &&
              getBooleanLabel(originalMetadata.ionizingRadiation) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.ionizingRadiation) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.cableTransportInstallationCombination !== null &&
            metadata?.cableTransportInstallationCombination !== undefined) ||
          (originalMetadata?.cableTransportInstallationCombination !== null &&
            originalMetadata?.cableTransportInstallationCombination !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Combinaison d'installation de transport à câbles</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.cableTransportInstallationCombination
                ) !==
                  getBooleanLabel(
                    metadata.cableTransportInstallationCombination
                  ),
            }"
            >{{
              getBooleanLabel(metadata.cableTransportInstallationCombination)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.cableTransportInstallationCombination
              ) !==
                getBooleanLabel(
                  metadata.cableTransportInstallationCombination
                ) &&
              getBooleanLabel(
                originalMetadata.cableTransportInstallationCombination
              ) !== null &&
              getBooleanLabel(
                originalMetadata.cableTransportInstallationCombination
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.cableTransportInstallationCombination
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.firefightingExplosiveMaterialShipping !== null &&
            metadata?.firefightingExplosiveMaterialShipping !== undefined) ||
          (originalMetadata?.firefightingExplosiveMaterialShipping !== null &&
            originalMetadata?.firefightingExplosiveMaterialShipping !==
              undefined)
        "
      >
        <span class="card__label" i18n
          >Envoi d'articles d'incendie ou d'explosion</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.firefightingExplosiveMaterialShipping
                ) !==
                  getBooleanLabel(
                    metadata.firefightingExplosiveMaterialShipping
                  ),
            }"
            >{{
              getBooleanLabel(metadata.firefightingExplosiveMaterialShipping)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.firefightingExplosiveMaterialShipping
              ) !==
                getBooleanLabel(
                  metadata.firefightingExplosiveMaterialShipping
                ) &&
              getBooleanLabel(
                originalMetadata.firefightingExplosiveMaterialShipping
              ) !== null &&
              getBooleanLabel(
                originalMetadata.firefightingExplosiveMaterialShipping
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.firefightingExplosiveMaterialShipping
              )
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.buildingCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.buildingCoverage)
  "
>
  <div cardTitle i18n>
    Bâtiment servant ou non qu'à l'entreprise ainsi qu'en PPE
  </div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.buildingCoverage?.withCoverage !== null &&
            metadata?.buildingCoverage?.withCoverage !== undefined) ||
          (originalMetadata?.buildingCoverage?.withCoverage !== null &&
            originalMetadata?.buildingCoverage?.withCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.buildingCoverage.withCoverage
                ) !== getBooleanLabel(metadata.buildingCoverage.withCoverage),
            }"
            >{{ getBooleanLabel(metadata.buildingCoverage.withCoverage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.buildingCoverage.withCoverage
              ) !== getBooleanLabel(metadata.buildingCoverage.withCoverage) &&
              getBooleanLabel(
                originalMetadata.buildingCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.buildingCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(originalMetadata.buildingCoverage.withCoverage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.buildingCoverage?.insuredSum !== undefined ||
          originalMetadata?.buildingCoverage?.insuredSum !== undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.buildingCoverage.insuredSum !==
                  metadata.buildingCoverage.insuredSum,
            }"
            >{{ metadata.buildingCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.buildingCoverage.insuredSum !==
                metadata.buildingCoverage.insuredSum &&
              originalMetadata.buildingCoverage.insuredSum !== null &&
              originalMetadata.buildingCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.buildingCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.buildingCoverage?.deductible !== undefined ||
          originalMetadata?.buildingCoverage?.deductible !== undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.buildingCoverage.deductible !==
                  metadata.buildingCoverage.deductible,
            }"
            >{{ metadata.buildingCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.buildingCoverage.deductible !==
                metadata.buildingCoverage.deductible &&
              originalMetadata.buildingCoverage.deductible !== null &&
              originalMetadata.buildingCoverage.deductible !== undefined
            "
            >{{ originalMetadata.buildingCoverage.deductible }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.itemsCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.itemsCoverage)
  "
>
  <div cardTitle i18n>Choses prises en charges</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.itemsCoverage?.withCoverage !== null &&
            metadata?.itemsCoverage?.withCoverage !== undefined) ||
          (originalMetadata?.itemsCoverage?.withCoverage !== null &&
            originalMetadata?.itemsCoverage?.withCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.itemsCoverage.withCoverage) !==
                  getBooleanLabel(metadata.itemsCoverage.withCoverage),
            }"
            >{{ getBooleanLabel(metadata.itemsCoverage.withCoverage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.itemsCoverage.withCoverage) !==
                getBooleanLabel(metadata.itemsCoverage.withCoverage) &&
              getBooleanLabel(originalMetadata.itemsCoverage.withCoverage) !==
                null &&
              getBooleanLabel(originalMetadata.itemsCoverage.withCoverage) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.itemsCoverage.withCoverage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.itemsCoverage?.insuredSum !== undefined ||
          originalMetadata?.itemsCoverage?.insuredSum !== undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.itemsCoverage.insuredSum !==
                  metadata.itemsCoverage.insuredSum,
            }"
            >{{ metadata.itemsCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.itemsCoverage.insuredSum !==
                metadata.itemsCoverage.insuredSum &&
              originalMetadata.itemsCoverage.insuredSum !== null &&
              originalMetadata.itemsCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.itemsCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.itemsCoverage?.deductible !== undefined ||
          originalMetadata?.itemsCoverage?.deductible !== undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.itemsCoverage.deductible !==
                  metadata.itemsCoverage.deductible,
            }"
            >{{ metadata.itemsCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.itemsCoverage.deductible !==
                metadata.itemsCoverage.deductible &&
              originalMetadata.itemsCoverage.deductible !== null &&
              originalMetadata.itemsCoverage.deductible !== undefined
            "
            >{{ originalMetadata.itemsCoverage.deductible }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.cisternCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.cisternCoverage)
  "
>
  <div cardTitle i18n>Citerne</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.cisternCoverage?.withCoverage !== null &&
            metadata?.cisternCoverage?.withCoverage !== undefined) ||
          (originalMetadata?.cisternCoverage?.withCoverage !== null &&
            originalMetadata?.cisternCoverage?.withCoverage !== undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.cisternCoverage.withCoverage
                ) !== getBooleanLabel(metadata.cisternCoverage.withCoverage),
            }"
            >{{ getBooleanLabel(metadata.cisternCoverage.withCoverage) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.cisternCoverage.withCoverage) !==
                getBooleanLabel(metadata.cisternCoverage.withCoverage) &&
              getBooleanLabel(originalMetadata.cisternCoverage.withCoverage) !==
                null &&
              getBooleanLabel(originalMetadata.cisternCoverage.withCoverage) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.cisternCoverage.withCoverage)
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.cisternCoverage?.insuredSum !== undefined ||
          originalMetadata?.cisternCoverage?.insuredSum !== undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.cisternCoverage.insuredSum !==
                  metadata.cisternCoverage.insuredSum,
            }"
            >{{ metadata.cisternCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.cisternCoverage.insuredSum !==
                metadata.cisternCoverage.insuredSum &&
              originalMetadata.cisternCoverage.insuredSum !== null &&
              originalMetadata.cisternCoverage.insuredSum !== undefined
            "
            >{{ originalMetadata.cisternCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.cisternCoverage?.deductible !== undefined ||
          originalMetadata?.cisternCoverage?.deductible !== undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.cisternCoverage.deductible !==
                  metadata.cisternCoverage.deductible,
            }"
            >{{ metadata.cisternCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.cisternCoverage.deductible !==
                metadata.cisternCoverage.deductible &&
              originalMetadata.cisternCoverage.deductible !== null &&
              originalMetadata.cisternCoverage.deductible !== undefined
            "
            >{{ originalMetadata.cisternCoverage.deductible }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.installationAssemblyCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.installationAssemblyCoverage)
  "
>
  <div cardTitle i18n>Combinaison installation/montage</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.installationAssemblyCoverage?.withCoverage !== null &&
            metadata?.installationAssemblyCoverage?.withCoverage !==
              undefined) ||
          (originalMetadata?.installationAssemblyCoverage?.withCoverage !==
            null &&
            originalMetadata?.installationAssemblyCoverage?.withCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.installationAssemblyCoverage.withCoverage
                ) !==
                  getBooleanLabel(
                    metadata.installationAssemblyCoverage.withCoverage
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.installationAssemblyCoverage.withCoverage
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.installationAssemblyCoverage.withCoverage
              ) !==
                getBooleanLabel(
                  metadata.installationAssemblyCoverage.withCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.installationAssemblyCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.installationAssemblyCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.installationAssemblyCoverage.withCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.installationAssemblyCoverage?.insuredSum !== undefined ||
          originalMetadata?.installationAssemblyCoverage?.insuredSum !==
            undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.installationAssemblyCoverage.insuredSum !==
                  metadata.installationAssemblyCoverage.insuredSum,
            }"
            >{{ metadata.installationAssemblyCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.installationAssemblyCoverage.insuredSum !==
                metadata.installationAssemblyCoverage.insuredSum &&
              originalMetadata.installationAssemblyCoverage.insuredSum !==
                null &&
              originalMetadata.installationAssemblyCoverage.insuredSum !==
                undefined
            "
            >{{
              originalMetadata.installationAssemblyCoverage.insuredSum
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.installationAssemblyCoverage?.deductible !== undefined ||
          originalMetadata?.installationAssemblyCoverage?.deductible !==
            undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.installationAssemblyCoverage.deductible !==
                  metadata.installationAssemblyCoverage.deductible,
            }"
            >{{ metadata.installationAssemblyCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.installationAssemblyCoverage.deductible !==
                metadata.installationAssemblyCoverage.deductible &&
              originalMetadata.installationAssemblyCoverage.deductible !==
                null &&
              originalMetadata.installationAssemblyCoverage.deductible !==
                undefined
            "
            >{{
              originalMetadata.installationAssemblyCoverage.deductible
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.workingCommunitiesCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.workingCommunitiesCoverage)
  "
>
  <div cardTitle i18n>Communautés de travail/Consortium</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.workingCommunitiesCoverage?.withCoverage !== null &&
            metadata?.workingCommunitiesCoverage?.withCoverage !== undefined) ||
          (originalMetadata?.workingCommunitiesCoverage?.withCoverage !==
            null &&
            originalMetadata?.workingCommunitiesCoverage?.withCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.workingCommunitiesCoverage.withCoverage
                ) !==
                  getBooleanLabel(
                    metadata.workingCommunitiesCoverage.withCoverage
                  ),
            }"
            >{{
              getBooleanLabel(metadata.workingCommunitiesCoverage.withCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.workingCommunitiesCoverage.withCoverage
              ) !==
                getBooleanLabel(
                  metadata.workingCommunitiesCoverage.withCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.workingCommunitiesCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.workingCommunitiesCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.workingCommunitiesCoverage.withCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.workingCommunitiesCoverage?.insuredSum !== undefined ||
          originalMetadata?.workingCommunitiesCoverage?.insuredSum !== undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.workingCommunitiesCoverage.insuredSum !==
                  metadata.workingCommunitiesCoverage.insuredSum,
            }"
            >{{ metadata.workingCommunitiesCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.workingCommunitiesCoverage.insuredSum !==
                metadata.workingCommunitiesCoverage.insuredSum &&
              originalMetadata.workingCommunitiesCoverage.insuredSum !== null &&
              originalMetadata.workingCommunitiesCoverage.insuredSum !==
                undefined
            "
            >{{ originalMetadata.workingCommunitiesCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.workingCommunitiesCoverage?.deductible !== undefined ||
          originalMetadata?.workingCommunitiesCoverage?.deductible !== undefined
        "
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.workingCommunitiesCoverage.deductible !==
                  metadata.workingCommunitiesCoverage.deductible,
            }"
            >{{ metadata.workingCommunitiesCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.workingCommunitiesCoverage.deductible !==
                metadata.workingCommunitiesCoverage.deductible &&
              originalMetadata.workingCommunitiesCoverage.deductible !== null &&
              originalMetadata.workingCommunitiesCoverage.deductible !==
                undefined
            "
            >{{ originalMetadata.workingCommunitiesCoverage.deductible }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.workedObjectBasicCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.workedObjectBasicCoverage)
  "
>
  <div cardTitle i18n>Couverture de l'objet travaillé : base</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.workedObjectBasicCoverage?.withCoverage !== null &&
            metadata?.workedObjectBasicCoverage?.withCoverage !== undefined) ||
          (originalMetadata?.workedObjectBasicCoverage?.withCoverage !== null &&
            originalMetadata?.workedObjectBasicCoverage?.withCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.workedObjectBasicCoverage.withCoverage
                ) !==
                  getBooleanLabel(
                    metadata.workedObjectBasicCoverage.withCoverage
                  ),
            }"
            >{{
              getBooleanLabel(metadata.workedObjectBasicCoverage.withCoverage)
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.workedObjectBasicCoverage.withCoverage
              ) !==
                getBooleanLabel(
                  metadata.workedObjectBasicCoverage.withCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.workedObjectBasicCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.workedObjectBasicCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.workedObjectBasicCoverage.withCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.workedObjectBasicCoverage?.insuredSum !== undefined ||
          originalMetadata?.workedObjectBasicCoverage?.insuredSum !== undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.workedObjectBasicCoverage.insuredSum !==
                  metadata.workedObjectBasicCoverage.insuredSum,
            }"
            >{{ metadata.workedObjectBasicCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.workedObjectBasicCoverage.insuredSum !==
                metadata.workedObjectBasicCoverage.insuredSum &&
              originalMetadata.workedObjectBasicCoverage.insuredSum !== null &&
              originalMetadata.workedObjectBasicCoverage.insuredSum !==
                undefined
            "
            >{{ originalMetadata.workedObjectBasicCoverage.insuredSum }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.workedObjectBasicCoverage?.deductible !== undefined ||
          originalMetadata?.workedObjectBasicCoverage?.deductible !== undefined
        "
      >
        <span class="card__label" i18n>Franchise (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.workedObjectBasicCoverage.deductible !==
                  metadata.workedObjectBasicCoverage.deductible,
            }"
            >{{ metadata.workedObjectBasicCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.workedObjectBasicCoverage.deductible !==
                metadata.workedObjectBasicCoverage.deductible &&
              originalMetadata.workedObjectBasicCoverage.deductible !== null &&
              originalMetadata.workedObjectBasicCoverage.deductible !==
                undefined
            "
            >{{ originalMetadata.workedObjectBasicCoverage.deductible }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card
  class="flex-basis-100 mb-12"
  *ngIf="
    !isGenericCoverageEmpty(metadata?.workedObjectExtendedCoverage) ||
    !isGenericCoverageEmpty(originalMetadata?.workedObjectExtendedCoverage)
  "
>
  <div cardTitle i18n>Couverture de l'objet travaillé : élargie</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.workedObjectExtendedCoverage?.withCoverage !== null &&
            metadata?.workedObjectExtendedCoverage?.withCoverage !==
              undefined) ||
          (originalMetadata?.workedObjectExtendedCoverage?.withCoverage !==
            null &&
            originalMetadata?.workedObjectExtendedCoverage?.withCoverage !==
              undefined)
        "
      >
        <span class="card__label" i18n>Couverture</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(
                  originalMetadata.workedObjectExtendedCoverage.withCoverage
                ) !==
                  getBooleanLabel(
                    metadata.workedObjectExtendedCoverage.withCoverage
                  ),
            }"
            >{{
              getBooleanLabel(
                metadata.workedObjectExtendedCoverage.withCoverage
              )
            }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(
                originalMetadata.workedObjectExtendedCoverage.withCoverage
              ) !==
                getBooleanLabel(
                  metadata.workedObjectExtendedCoverage.withCoverage
                ) &&
              getBooleanLabel(
                originalMetadata.workedObjectExtendedCoverage.withCoverage
              ) !== null &&
              getBooleanLabel(
                originalMetadata.workedObjectExtendedCoverage.withCoverage
              ) !== undefined
            "
            >{{
              getBooleanLabel(
                originalMetadata.workedObjectExtendedCoverage.withCoverage
              )
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.workedObjectExtendedCoverage?.insuredSum !== undefined ||
          originalMetadata?.workedObjectExtendedCoverage?.insuredSum !==
            undefined
        "
      >
        <span class="card__label" i18n>Somme d'assurance (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.workedObjectExtendedCoverage.insuredSum !==
                  metadata.workedObjectExtendedCoverage.insuredSum,
            }"
            >{{ metadata.workedObjectExtendedCoverage.insuredSum }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.workedObjectExtendedCoverage.insuredSum !==
                metadata.workedObjectExtendedCoverage.insuredSum &&
              originalMetadata.workedObjectExtendedCoverage.insuredSum !==
                null &&
              originalMetadata.workedObjectExtendedCoverage.insuredSum !==
                undefined
            "
            >{{
              originalMetadata.workedObjectExtendedCoverage.insuredSum
            }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.workedObjectExtendedCoverage?.deductible !== undefined ||
          originalMetadata?.workedObjectExtendedCoverage?.deductible !==
            undefined
        "
      >
        <span class="card__label" i18n>Franchise (CHF)</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.workedObjectExtendedCoverage.deductible !==
                  metadata.workedObjectExtendedCoverage.deductible,
            }"
            >{{ metadata.workedObjectExtendedCoverage.deductible }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.workedObjectExtendedCoverage.deductible !==
                metadata.workedObjectExtendedCoverage.deductible &&
              originalMetadata.workedObjectExtendedCoverage.deductible !==
                null &&
              originalMetadata.workedObjectExtendedCoverage.deductible !==
                undefined
            "
            >{{
              originalMetadata.workedObjectExtendedCoverage.deductible
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>

<app-card class="flex-basis-100 mb-12" *ngIf="hasCurrentInsuranceInfo()">
  <div cardTitle i18n>Assurance actuelle</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows w-100">
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasInsurance !== null &&
            metadata?.hasInsurance !== undefined) ||
          (originalMetadata?.hasInsurance !== null &&
            originalMetadata?.hasInsurance !== undefined)
        "
      >
        <span class="card__label" i18n>Possède une assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasInsurance) !==
                  getBooleanLabel(metadata.hasInsurance),
            }"
            >{{ getBooleanLabel(metadata.hasInsurance) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasInsurance) !==
                getBooleanLabel(metadata.hasInsurance) &&
              getBooleanLabel(originalMetadata.hasInsurance) !== null &&
              getBooleanLabel(originalMetadata.hasInsurance) !== undefined
            "
            >{{ getBooleanLabel(originalMetadata.hasInsurance) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.currentInsurer || originalMetadata?.currentInsurer"
      >
        <span class="card__label" i18n>Assureur actuel</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                originalMetadata.currentInsurer !== metadata.currentInsurer,
            }"
            >{{ metadata.currentInsurer }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              originalMetadata.currentInsurer !== metadata.currentInsurer &&
              originalMetadata.currentInsurer !== null &&
              originalMetadata.currentInsurer !== undefined
            "
            >{{ originalMetadata.currentInsurer }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          (metadata?.hasClaimsLastFiveYears !== null &&
            metadata?.hasClaimsLastFiveYears !== undefined) ||
          (originalMetadata?.hasClaimsLastFiveYears !== null &&
            originalMetadata?.hasClaimsLastFiveYears !== undefined)
        "
      >
        <span class="card__label" i18n
          >A subi des sinistres ces 5 dernières années</span
        >
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata &&
                getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                  getBooleanLabel(metadata.hasClaimsLastFiveYears),
            }"
            >{{ getBooleanLabel(metadata.hasClaimsLastFiveYears) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                getBooleanLabel(metadata.hasClaimsLastFiveYears) &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                null &&
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears) !==
                undefined
            "
            >{{
              getBooleanLabel(originalMetadata.hasClaimsLastFiveYears)
            }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
